import { Routes } from '@angular/router';

import { authGuard } from '@guards';

export const IdentityRoutes: Routes = [
    {
        path: 'signIn',
        loadComponent: () => import('./login/login.component').then(c => c.LoginComponent),
        title: 'Sign in',
        canActivate: [authGuard]
    },
    {
        path: 'signup',
        loadComponent: () => import('./signup/signup.component').then(c => c.SignupComponent),
        title: 'Sign up',
        canActivate: [authGuard]
    },
    {
        path: 'forgot-password',
        loadComponent: () => import('./forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent),
        title: 'Forgot password',
        canActivate: [authGuard]
    },
    {
        path: 'reset-password',
        loadComponent: () => import('./reset-password/reset-password.component').then(c => c.ResetPasswordComponent),
        title: 'Reset password',
        canActivate: [authGuard]
    },
    {
        path: 'reset-password/:code',
        loadComponent: () => import('./reset-password/reset-password.component').then(c => c.ResetPasswordComponent),
        title: 'Reset password',
        canActivate: [authGuard]
    },
    {
        path: 'verify',
        loadComponent: () => import('./verify-user/verify-user.component').then(c => c.VerifyUserComponent),
        title: 'Verify user',
    },
    {
        path: 'verify/:code',
        loadComponent: () => import('./verify-user/verify-user.component').then(c => c.VerifyUserComponent),
        title: 'Verify user',
    },
    {
        path: 'change-password',
        loadComponent: () => import('./change-password/change-password.component').then(c => c.ChangePasswordComponent),
        title: 'Change password',
        canActivate: [authGuard]
    },
    {
        path: 'authorize',
        loadComponent: () => import('./authorize/authorize.component').then(c => c.AuthorizeComponent),
        title: 'Authorize',
    }
];
